export const SkipIcon = () => (
  <svg
    width='17.5'
    height='15.5'
    viewBox='0 0 17.5 15.5003'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M12.6851 8.37592C12.4307 9.5876 11.077 10.4578 8.36976 12.1983C5.42528 14.0913 3.95304 15.0377 2.76052 14.6731C2.35662 14.5496 1.98463 14.3324 1.67227 14.0378C0.75 13.1679 0.75 11.362 0.75 7.75016C0.75 4.13833 0.75 2.33241 1.67227 1.46252C1.98463 1.16789 2.35662 0.950734 2.76052 0.827233C3.95304 0.462589 5.42528 1.40907 8.36976 3.30202C11.077 5.04249 12.4307 5.91272 12.6851 7.12441C12.7716 7.53668 12.7716 7.96365 12.6851 8.37592Z'
      stroke='white'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
    <path
      d='M16.75 0.750163V14.7502'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
)
